import { createSelector } from 'reselect'
import flocabularyUrlSelector from 'redux/selectors/flocabulary/flocabulary_external_url_selector'

const flocabularySelector = state => state.flocabulary

const videoSelector = createSelector(
	[flocabularySelector, flocabularyUrlSelector],
	(flocabulary, flocabularyUrl) => {
		const currentVideo = flocabulary.videos.find(video => video.contentId === flocabulary.selectedVideoId)
		let contentId = ''
		let videoTitle = ''
		let externalSource = ''

		if (currentVideo) {
			const gradeTitle = currentVideo.grade ? `, ${currentVideo.grade}` : ''
			videoTitle = `${currentVideo.title}${gradeTitle}`
			contentId = currentVideo.contentId
			externalSource = flocabularyUrl.externalSource
		}
		return {
			contentId,
			videoTitle,
			externalSource,
		}
	}
)

export default videoSelector
